module.exports = __webpack_public_path__ + "static/media/icons-ic-reschedule-demo-transferred.7506bdab.svg";